import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import TasksOverviewCard from './TasksOverviewCard';

const TasksOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('tasks:task_page.title')} />
      <TasksOverviewCard autoFocus={true} />
    </ContentLayout>
  );
};

export default TasksOverviewPage;
